import type { FC } from 'react';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

import styled from 'styled-components';

export const CollapseSidebarButton: FC<{ toggleCollapse: () => void; isCollapsed: boolean }> = ({
  toggleCollapse,
  isCollapsed
}) => (
  <StyledButton onClick={toggleCollapse}>
    {isCollapsed ? <KeyboardDoubleArrowRightIcon /> : <KeyboardDoubleArrowLeftIcon />}
  </StyledButton>
);

const StyledButton = styled.button`
  position: absolute;
  box-shadow: 2px 0 3px rgb(80 90 98 / 50%);
  top: calc(50% - 20px);
  z-index: 1;
  background-color: inherit;
  border: 0;
  border-radius: 50%;
  color: inherit;
  display: flex;
  clip-path: polygon(50.9% 0%, 120% 0%, 120% 100%, 50% 100%);
  width: 40px;
  height: 40px;
  left: -11px;
  & > svg {
    margin-top: 10px;
    margin-left: 18px;
    font-size: 19px;
  }
  &:hover {
    cursor: pointer;
  }
`;
